/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriceType = {
    PerStudent: 'PerStudent',
    Total: 'Total'
} as const;
export type PriceType = typeof PriceType[keyof typeof PriceType];


export function instanceOfPriceType(value: any): boolean {
    for (const key in PriceType) {
        if (Object.prototype.hasOwnProperty.call(PriceType, key)) {
            if (PriceType[key as keyof typeof PriceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriceTypeFromJSON(json: any): PriceType {
    return PriceTypeFromJSONTyped(json, false);
}

export function PriceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceType {
    return json as PriceType;
}

export function PriceTypeToJSON(value?: PriceType | null): any {
    return value as any;
}

export function PriceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PriceType {
    return value as PriceType;
}

